import React, { useState } from 'react';
import { PencilIcon } from 'lucide-react';
interface InlineTextFieldProps {
  value: string;
  onSave: (value: string) => void;
  ariaLabel: string;
  placeholder?: string;
  textClassName?: string;
}
export function InlineTextField({
  value,
  onSave,
  ariaLabel,
  placeholder = 'Add…',
  textClassName = ''
}: InlineTextFieldProps) {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(value);
  function commit() {
    const next = draft.trim();
    if (next !== value) onSave(next);
    setEditing(false);
  }
  if (editing) {
    return <input autoFocus value={draft} aria-label={ariaLabel} onChange={e => setDraft(e.target.value)} onBlur={commit} onKeyDown={e => {
      if (e.key === 'Enter') commit();
      if (e.key === 'Escape') {
        setDraft(value);
        setEditing(false);
      }
    }} className={`-mx-1 block w-full rounded border border-brand bg-white px-1 py-0 focus:outline-none focus:ring-1 focus:ring-brand ${textClassName}`} data-id="element-224" data-mp="3osojx09qoxtw" />;
  }
  return <button type="button" onClick={() => {
    setDraft(value);
    setEditing(true);
  }} aria-label={`Edit ${ariaLabel}: ${value || 'empty'}`} title={value} className="group -mx-1 flex w-full min-w-0 items-center gap-1.5 rounded px-1 text-left hover:bg-slate-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand" data-id="element-225" data-mp="3uv3mfvwm359e">
      <span className={`truncate ${value ? '' : 'italic text-slate-400'} ${textClassName}`} data-id="element-226" data-mp="3c66sjt54merp">{value || placeholder}</span>
      <PencilIcon className="h-3 w-3 shrink-0 text-slate-400 opacity-0 transition-opacity group-hover:opacity-100" aria-hidden="true" data-id="element-227" data-mp="3pxliyl1d5i8s" />
    </button>;
}